import { render, staticRenderFns } from "./Connects.vue?vue&type=template&id=380478a1"
import script from "./Connects.vue?vue&type=script&lang=js"
export * from "./Connects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports